<template>
  <div>
    <my-header/>

    <div class="race-box">

      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'derby_list'}">Скачки</b-breadcrumb-item>
        <template v-if="raceParentInfo !== null">
          <b-breadcrumb-item :to="derbyLocation">Скачки {{ derbyId }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{name:'derby_leagues', params: { derbyId: derbyId }}">Лига {{ leagueId }}</b-breadcrumb-item>
        </template>
      </b-breadcrumb>

      <h2>Заезд {{ raceId }}</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <router-view></router-view>
      </div>

    </div>

  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import { createDerbyLocation } from '../../model/race.js';

import MyHeader from '../Header.vue';
import SideNav from '../SideNav.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'DerbyRace',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    raceId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      raceParentInfo: null,
    };
  },

  computed: {
    derbyId() {
      return this.raceParentInfo.derbyId;
    },

    leagueId() {
      return this.raceParentInfo.leagueId;
    },

    derbyLocation() {
      return createDerbyLocation(this.derbyId);
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'derby_race_info', params: {raceId: this.raceId}},
          exact: true,
        },
        {
          title: 'Игроки',
          route: {name: 'derby_race_rating', params: {raceId: this.raceId}},
        },
      ];
    },
  },

  created() {
    this.loadRaceParentInfo();
  },

  methods: {
    loadRaceParentInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const raceId = this.raceId;
      const url = `/derby_race/${raceId}/parent_info`;

      HTTP.get(url)
      .then(response => {
        this.raceParentInfo = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
.race-box {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}
</style>